<template>
<transition name="editor_fade">
<div class="schema_editor_wrap" v-if="show_editor" @click="detectOutside">
<div class="schema_editor_wrap_inner grid pt-5">

<div class="view_switch">
<CustomSwitch 
:initialstate="false" 
@updated="viewUpdated" 
on_icon="smartphone" 
off_icon="computer" 
on_bg_color="rgb(126, 47, 141)"
off_bg_color="#352f8d"
on_value="mobile"
off_value="desktop"
/>
</div>


<div class="save_button" v-if="ready_to_save">
<Button icon="pi pi-check" class=" p-button-success p-button-outlined  p-button-sm " @click="closeSchemaEditor"></Button>
</div>
<div class="close_btn">
<Button icon="pi pi-times" class=" p-button-primary p-button-outlined  p-button-sm " @click="closeSchemaEditor"></Button>
</div>


<SchemaEditorBlocks
@orderChanged="orderChanged"
/>

<SchemaEditorDisplay 
:view_mode="view_mode"
@orderChanged="orderChanged"
/>


<SchemaEditorConfigs />




</div>
</div>
</transition>
</template>

<script>
import SchemaEditorBlocks from "./SchemaEditorBlocks"
import SchemaEditorDisplay from "./SchemaEditorDisplay"
import SchemaEditorConfigs from "./SchemaEditorConfigs"


export default {

  name: 'SchemaEditor',
  props:["button_coordinates"],
  data () {
    return {
    	show_editor:false,
    	left:0,
    	top:0,
    	view_mode:"desktop",
    	selected_element:null,
    	theschema:[],
    	ready_to_save:false,
    }
  },  
  components:{SchemaEditorBlocks,SchemaEditorDisplay,SchemaEditorConfigs},
  watch:{
    blocks(newval,oldval)
    {
    	if(this.blocks.length)
    	{
    		this.ready_to_save = true
    	}
    	else
    	{
    		this.ready_to_save = false
    	}
      
    },
  },
  computed:{
    blocks()
    {
      return this.$store.state.customresultdisplays.schema
    },
  },
  mounted()
  {

  },
  methods:{  
  	detectOutside(event)
  	{
  		let outside_left_panel = false
  		let outside_right_panel = false
  		let outside_display = false
  		if(!event.target.closest('.left_panel')) 
  		{
		     outside_left_panel = true
		  }
		  if(!event.target.closest('.right_panel')) 
  		{
		     outside_right_panel = true
		  }
		  if(!event.target.closest('.editor_viewport_wrap')) 
  		{
		     outside_display = true
		  }
		  if(outside_left_panel && outside_right_panel && outside_display)
		  {
		  	this.$store.dispatch('customresultdisplays/setSelectedElement',null) 
		  }
  	},
  	orderChanged(data)
  	{
  		this.theschema = data
  		this.$store.dispatch('customresultdisplays/setSchema',this.theschema) 
  	},
  	viewUpdated(data)
  	{
  		console.log(data)
  		this.view_mode = data
  	},
  	openSchemaEditor(left,top)	
  	{
  		this.left = left+"px"
  		this.top = top+"px"
  		this.show_editor = true
  	},
  	closeSchemaEditor()
  	{
  		this.show_editor = false
  	},
  }
}
</script>

<style lang="css" scoped>
.schema_editor_wrap{
	width: 100%;
	height: 100vh;
	position: fixed;
	top: 0;
	left: 0;
	background-color: rgba(0,0,0,0.3);
	z-index: 1600;
	padding: 7px;
	transform-origin: v-bind('left') v-bind('top');
}
.schema_editor_wrap_inner{
	position: relative;
	min-height: 100vh;
	background-color: #F3F5F9;
	border-radius: 4px;
}
.close_btn{
	position: absolute;
	right: 4px;
	top: 4px;
}
.save_button{
	position: absolute;
	left: 4px;
	top: 4px;
}
.view_switch{
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	top: 5px;
	width: 100%;
}
.editor_fade-enter-active, .editor_fade-leave-active {
  transition: all  .3s;  
}
.editor_fade-enter-from, .editor_fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0,0);
}
.editor_fade-enter-to,.editor_fade-leave-from{
	transform: scale(1,1);
	opacity: 1;
}
</style>